import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../styles'
import classNames from 'classnames'

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		spanSmall: {
			width: '70%'
		}

	}
))

interface AcceptingProps {
	label: string,
	isLargeScreen: boolean
}

type LabelProps = AcceptingProps

const LabelTab: React.FC<LabelProps> = (
	{
		label,
		isLargeScreen
	}
) => {
	const classes = useStyle()
	const buttonTitle = classNames(
		isLargeScreen? classes.text1 : classes.text17,
		classes.semiBold,
		{
			[classes.spanSmall] : !isLargeScreen
		}
	)
	return (
		<span className={buttonTitle}>
			{label}
		</span>
	)
}

export default LabelTab